import {Determinant} from "./determinant";

export class CollectionPlaceDeterminant extends Determinant {

  public determinantType = "COLLECTION_PLACE";
  public registrationServiceLocationId: string;
  public selected = true;

}
